import { create } from 'zustand';

export type SearchScope = 'all' | 'doc' | 'task' | 'code' | 'tag';

export interface SearchResultItem {
  id: string;
  documentPath: string;
  documentTitle: string;
  title: string;
  snippet: string;
  scope: 'doc' | 'task' | 'code' | 'tag';
  score?: number;
  lineNumber?: number;
}

interface SearchState {
  isOpen: boolean;
  query: string;
  activeScope: SearchScope;
  results: SearchResultItem[];
  selectedIndex: number;

  setOpen: (isOpen: boolean) => void;
  setQuery: (query: string) => void;
  setActiveScope: (scope: SearchScope) => void;
  setResults: (results: SearchResultItem[]) => void;
  setSelectedIndex: (index: number) => void;
  resetSearch: () => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  isOpen: false,
  query: '',
  activeScope: 'all',
  results: [],
  selectedIndex: 0,

  setOpen: (isOpen) => set({ isOpen }),
  setQuery: (query) => set({ query, selectedIndex: 0 }),
  setActiveScope: (activeScope) => set({ activeScope, selectedIndex: 0 }),
  setResults: (results) => set({ results }),
  setSelectedIndex: (selectedIndex) => set({ selectedIndex }),
  resetSearch: () => set({ isOpen: false, query: '', activeScope: 'all', results: [], selectedIndex: 0 })
}));
